import FondationsApiModel from '../global/FondationsApiModel';

export default class ServiceTagModel extends FondationsApiModel {
	static get path(): string {
		return '/service_tags/{?id}';
	}
}
